export default __webpack_public_path__ + "static/media/currency_usd.fa6e3b7a.svg";